import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {FormattedMessage} from "react-intl";

class QuestSUS extends Component{

    state = {
        questValue1: null,
        questValue2: null,
        questValue3: null,
        questValue4: null,
        questValue5: null,
        questValue6: null,
        questValue7: null,
        questValue8: null,
        questValue9: null,
        questValue10: null

    };

    submitForm = () => {
        console.log(this.state.questValue1, this.state.questValue2, this.state.questValue3,this.state.questValue4,this.state.questValue5,
            this.state.questValue6,this.state.questValue7,this.state.questValue8,this.state.questValue9,this.state.questValue10)

    };

    changeQuest1 = (event) => {
        console.log(event.target.value);
        this.setState({questValue1: event.target.value})
    };
    changeQuest2 = (event) => {
        console.log(event.target.value);
        this.setState({questValue2: event.target.value})
    };
    changeQuest3 = (event) => {
        console.log(event.target.value);
        this.setState({questValue3: event.target.value})
    };
    changeQuest4 = (event) => {
        console.log(event.target.value);
        this.setState({questValue4: event.target.value})
    };
    changeQuest5 = (event) => {
        console.log(event.target.value);
        this.setState({questValue5: event.target.value})
    };
    changeQuest6 = (event) => {
        console.log(event.target.value);
        this.setState({questValue6: event.target.value})
    };
    changeQuest7 = (event) => {
        console.log(event.target.value);
        this.setState({questValue7: event.target.value})
    };
    changeQuest8 = (event) => {
        console.log(event.target.value);
        this.setState({questValue8: event.target.value})
    };
    changeQuest9 = (event) => {
        console.log(event.target.value);
        this.setState({questValue9: event.target.value})
    };
    changeQuest10 = (event) => {
        console.log(event.target.value);
        this.setState({questValue10: event.target.value})
    };

    render(){
        return(
            <div className="container col-12 mt-6 mr-0 ml-0">
                <h4 className="text-primary">Questionário de Usabilidade</h4>
                <br/>
                <form className="form-insert" id="questSUS" name="questSUS">
                    <div className="form-group">
                        <label htmlFor="quest1">1. Acho que gostaria de utilizar este produto com frequência.</label>
                        <br/>
                        <label className="radio-inline" onChange={this.changeQuest1}>
                            <input type="radio" id="radioButton" name="optradio1" value="1"/>1
                            <input type="radio" id="radioButton" name="optradio1" value="2"/>2
                            <input type="radio" id="radioButton" name="optradio1" value="3"/>3
                            <input type="radio" id="radioButton" name="optradio1" value="4"/>4
                            <input type="radio" id="radioButton" name="optradio1" value="5"/>5
                        </label>
                    </div>
                    <div className="form-group">
                        <label htmlFor="quest2">2. Considerei o produto mais complexo do que necessário.</label>
                        <br/>
                        <label className="radio-inline" onChange={this.changeQuest2}>
                            <input type="radio" id="radioButton" name="optradio2" value="1"/>1
                            <input type="radio" id="radioButton" name="optradio2" value="2"/>2
                            <input type="radio" id="radioButton" name="optradio2" value="3"/>3
                            <input type="radio" id="radioButton" name="optradio2" value="4"/>4
                            <input type="radio" id="radioButton" name="optradio2" value="5"/>5
                        </label>
                    </div> <div className="form-group" onChange={this.changeQuest3}>
                        <label htmlFor="quest3">3. Achei o produto fácil de usar.</label>
                        <br/>
                        <label className="radio-inline">
                            <input type="radio" id="radioButton" name="optradio3" value="1"/>1
                            <input type="radio" id="radioButton" name="optradio3" value="2"/>2
                            <input type="radio" id="radioButton" name="optradio3" value="3"/>3
                            <input type="radio" id="radioButton" name="optradio3" value="4"/>4
                            <input type="radio" id="radioButton" name="optradio3" value="5"/>5
                        </label>
                    </div> <div className="form-group">
                        <label htmlFor="quest4">4. Acho que necessitaria de ajuda de uma pessoa com conhecimentos técnicos para utilizar o produto.</label>
                        <br/>
                        <label className="radio-inline" onChange={this.changeQuest4}>
                            <input type="radio" id="radioButton" name="optradio4" value="1"/>1
                            <input type="radio" id="radioButton" name="optradio4" value="2"/>2
                            <input type="radio" id="radioButton" name="optradio4" value="3"/>3
                            <input type="radio" id="radioButton" name="optradio4" value="4"/>4
                            <input type="radio" id="radioButton" name="optradio4" value="5"/>5
                        </label>
                    </div> <div className="form-group">
                        <label htmlFor="quest5">5. Acho que as várias funcionaliades do sistema estão muito bem integradas.</label>
                        <br/>
                        <label className="radio-inline" onChange={this.changeQuest5}>
                            <input type="radio" id="radioButton" name="optradio5" value="1"/>1
                            <input type="radio" id="radioButton" name="optradio5" value="2"/>2
                            <input type="radio" id="radioButton" name="optradio5" value="3"/>3
                            <input type="radio" id="radioButton" name="optradio5" value="4"/>4
                            <input type="radio" id="radioButton" name="optradio5" value="5"/>5
                        </label>
                    </div> <div className="form-group">
                        <label htmlFor="quest6">6. Acho que o produto apresenta muita inconsistência.</label>
                        <br/>
                        <label className="radio-inline" onChange={this.changeQuest6}>
                            <input type="radio" id="radioButton" name="optradio6" value="1"/>1
                            <input type="radio" id="radioButton" name="optradio6" value="2"/>2
                            <input type="radio" id="radioButton" name="optradio6" value="3"/>3
                            <input type="radio" id="radioButton" name="optradio6" value="4"/>4
                            <input type="radio" id="radioButton" name="optradio6" value="5"/>5
                        </label>
                    </div> <div className="form-group">
                        <label htmlFor="quest7">7. Imagino que as pessoas aprenderiam a utilziar este produto rapidamente.</label>
                        <br/>
                        <label className="radio-inline" onChange={this.changeQuest7}>
                            <input type="radio" id="radioButton" name="optradio7" value="1"/>1
                            <input type="radio" id="radioButton" name="optradio7" value="2"/>2
                            <input type="radio" id="radioButton" name="optradio7" value="3"/>3
                            <input type="radio" id="radioButton" name="optradio7" value="4"/>4
                            <input type="radio" id="radioButton" name="optradio7" value="5"/>5
                        </label>
                    </div>
                    <div className="form-group">
                        <label htmlFor="quest8">8. Achei o produto muito complicado de usar.</label>
                        <br/>
                        <label className="radio-inline" onChange={this.changeQuest8}>
                            <input type="radio" id="radioButton" name="optradio8" value="1"/>1
                            <input type="radio" id="radioButton" name="optradio8" value="2"/>2
                            <input type="radio" id="radioButton" name="optradio8" value="3"/>3
                            <input type="radio" id="radioButton" name="optradio8" value="4"/>4
                            <input type="radio" id="radioButton" name="optradio8" value="5"/>5
                        </label>
                    </div>
                 <div className="form-group">
                        <label htmlFor="quest9">9. Senti-me muito confiante ao utilizar o produto.</label>
                        <br/>
                        <label className="radio-inline" onChange={this.changeQuest9}>
                            <input type="radio" id="radioButton" name="optradio9" value="1"/>1
                            <input type="radio" id="radioButton" name="optradio9" value="2"/>2
                            <input type="radio" id="radioButton" name="optradio9" value="3"/>3
                            <input type="radio" id="radioButton" name="optradio9" value="4"/>4
                            <input type="radio" id="radioButton" name="optradio9" value="5"/>5
                        </label>
                    </div>
                 <div className="form-group">
                        <label htmlFor="quest10">10. Tive de aprender muito antes de conseguir lidar com este produto.</label>
                        <br/>
                        <label className="radio-inline" onChange={this.changeQuest10}>
                            <input type="radio" id="radioButton" name="optradio10" value="1"/>1
                            <input type="radio" id="radioButton" name="optradio10" value="2"/>2
                            <input type="radio" id="radioButton" name="optradio10" value="3"/>3
                            <input type="radio" id="radioButton" name="optradio10" value="4"/>4
                            <input type="radio" id="radioButton" name="optradio10" value="5"/>5
                        </label>
                    </div>
                </form>
                <button className="btn btn-lg btn-primary btn-block mt-4 text-white" onClick={this.submitForm}>Submeter</button>
            </div>
        )
    }

}

export default QuestSUS;



// WEBPACK FOOTER //
// ./src/containers/questSUS.js